import React, { useContext, Fragment } from 'react';
import { withStyles } from '@material-ui/core';
import Carousel from '../../carousel/Carousel';
import DataContext from '../../data/DataContext';
import { openLink } from '../../util/utilNative';

const styles = (theme) => ({
  root: {
    position: 'relative',
    letterSpacing: '-0.0313rem',
    margin: '0.375rem 0rem',
    zIndex: 1,
  },
  carousel: {
    width: '100%',
    height: '9rem',
  },
  item: {
    height: '2.3125rem',
    textAlign: 'center',
    color: theme.color.select.color,
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    padding: '0rem',
    flex: 1,
  },
  vertical: {
    height: 'auto',
  },
  list: {
    display: 'flex',
    margin: '0rem 1.25rem 0rem 1.25rem',
  },
  listitem: {
    width: '18rem',
    padding: '0rem 0.5rem 0rem 0rem',
    margin: '0 0 0.5rem 0',
  },
  card: {
    width: '16.25rem',
    height: '100%',
    flex: 'auto',
    background: theme.color.message.background_white,
    // border: "1px solid #e1e1e1",
    border: '0',
    borderRadius: '0.375rem',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 0.125rem 0.375rem 0 rgba(0, 0, 0, 0.1)',
    position: 'relative',
  },
  thumbnail: {
    height: '12.5rem',
    // padding: "15px 19px 12px",
  },
  thumbnailImage: {
    // width: "auto",
    // height: "103px",
    width: '100%',
    borderRadius: '0.75rem 0.75rem 0rem 0rem',
    height: '12.5rem',
  },
  tags: {
    // color: theme.color.button.label_sg,
    lineHeight: '1.17',
    margin: '0 1.25rem',
    textAlign: 'start',
  },
  tag: {
    fontSize: theme.font.size12,
    // outline: "none",
    background: 'transparent',
    border: 'none',
    textDecoration: 'underline',
    padding: '0',
    margin: '0 0.375rem 0 0',
    color: theme.color.button.label_sg,
  },
  storyType: {
    // outline: 'none',
    // border: "1px solid #262626",
    // borderRadius: "4px",
    background: '#fff',
    width: 'fit-content',
    margin: '1rem 1.25rem 0.25rem 1.25rem',
    // padding: "0px 8px",
    fontSize: theme.font.size11,
    fontWeight: 'bold',
    lineHeight: '1',
    letterSpacing: 'normal',
    color: theme.color.text_color.grey,
  },
  external: {
    display: 'flex',
    flexDirection: 'column',
    // background: "#fafafa",
    // borderTop: "1px solid #e1e1e1",
    // marginTop: "10px",
    padding: '1rem',
  },
  normalButton: {
    margin: '0.375rem 0 0 0',
  },
  externalButton: {
    backgroundColor: theme.color.button.background_red,
    borderRadius: '0.375rem',
    height: '2.5rem',
    color: theme.color.button.text_white,
    fontWeight: 'bold',
    fontSize: theme.font.size14,
    // flex: 1,
    textAlign: 'center',
    border: 'none',
    padding: 0,
    background: 'transparent',
    letterSpacing: 'normal',
    // "&:active": {
    //   background: "rgba(38, 38, 38, 0.1)",
    // },
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  title: {
    fontSize: theme.font.size14, // "15px",
    fontWeight: 'bold',
    color: theme.color.text_color.color,
    padding: '0 1.25rem',
    margin: '0 0 0.5rem 0',
    flexGrow: 1,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    // whiteSpace: "nowrap",
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    textAlign: 'start',
    lineHeight: '1.43',
    letterSpacing: 'normal',
  },
});

const Card = React.forwardRef((props, ref) => {
  const { classes, data } = props;
  const context = useContext(DataContext);

  const handleClick = (url, action, event) => {
    if (!ref.clickAllowed()) {
      return;
    }
    openLink(context, action, url, event);
  };

  const handleClickTag = (tag) => {
    context.addTXMessage(true, '#' + tag.tag_name + ' 스토리');
    context.request(
      context,
      '',
      'button',
      { to: 'THQ_OTHER_STORY', tag_id: tag.tag_id, tag_name: tag.tag_name },
      { mode: 'bypass', intent: 'DIRECT_MESSAGE' }
    );
  };

  const handleStoryType = (item) => {
    context.request(context, item.story_type + ' 스토리', 'text');
  };

  return data.items.map((item, key) => (
    <div
      key={key}
      className={classes.listitem}
      // role={'button'}
      // tabIndex={0}
      // aria-label={`${
      //   item.buttons[0].parameters.action === 'external'
      //     ? context.string.aria.external + ','
      //     : ''
      // } ${item.title}, 상세보기, ${key + 1}/${data.items.length}, 항목${
      //   data.items.length
      // }개`}
    >
      <div className={classes.card}>
        <div className={classes.thumbnail}>
          <img
            className={classes.thumbnailImage}
            src={item['thumbnail_url']}
            alt={item.title}
          />
        </div>

        {item.story_type && (
          <div onClick={() => handleStoryType(item)} className={classes.storyType}>
            {item.story_type}
          </div>
        )}
        {item.title && (
          <div
            className={classes.title}
            dangerouslySetInnerHTML={{ __html: item.title }}
          />
        )}
        {item.tags && (
          <div className={classes.tags}>
            {item.tags.map((tag) => {
              return (
                <button className={classes.tag} onClick={() => handleClickTag(tag)}>
                  #{tag.tag_name}
                </button>
              );
            })}
          </div>
        )}

        <div className={classes.external}>
          {item.buttons.map((button, index) => (
            <Fragment key={index}>
              {/* <Divider
                className={classes.externalDivider}
                orientation="vertical"
                hidden={index === 0}
                component={"div"}
                disabled
              /> */}
              <button
                type="button"
                className={[
                  classes.externalButton,
                  index !== 0 && classes.normalButton,
                ].join(' ')}
                disabled={context.conversationEnd}
                onClick={() =>
                  handleClick(
                    context.userAgent.deviceType === 'mobile'
                      ? button.parameters.mobile_url
                      : button.parameters.url,
                    button.parameters.action,
                    button.event_action
                  )
                }
                title={`${
                  item.buttons[0].parameters.action === 'external'
                    ? context.string.aria.external + ','
                    : ''
                } ${item.title}, 상세보기, ${key + 1}/${data.items.length}, 항목${
                  data.items.length
                }개`}
              >
                <div className={classes.buttonContainer}>
                  <div>{button.label}</div>
                </div>
              </button>
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  ));
});

function StoryCard(props) {
  const { classes, data } = props;
  const context = useContext(DataContext);

  return (
    <>
      <div className={classes.root}>
        <Carousel
          className={classes.carousel}
          component={withStyles(styles)(Card)}
          data={data}
          ariaLabel={context.string.aria.event}
        />
      </div>
    </>
  );
}
export default withStyles(styles)(StoryCard);
